import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";

@Component({
  selector: "app-typeahead",
  templateUrl: "./typeahead.component.html",
  styleUrls: ["./typeahead.component.css"],
})
export class TypeaheadComponent implements OnInit, OnDestroy {
  /** force=true: botão Buscar — termo com 4+ caracteres. force=false: só4, 8, 12… ao digitar. */
  @Input() onType: (value: string, force?: boolean) => void = () => {};
  @Input() disabled: boolean = false;
  @Input() options: string[] = [];
  @Input() onOptionClick: (value: string) => void = () => {};
  @Input() loading: boolean = false;

  inputValue: string = "";
  showDropdown: boolean = false;

  private readonly minChars = 2;
  /** Aguarda esta pausa após parar de digitar antes de disparar a busca automática. */
  private readonly debounceDigitacaoMs = 1011;
  private readonly input$ = new Subject<string>();
  private subscription?: Subscription;

  ngOnInit(): void {
    this.subscription = this.input$
      .pipe(
        map((v) => (v ?? "").trim()),
        debounceTime(this.debounceDigitacaoMs),
        distinctUntilChanged()
      )
      .subscribe((value) => {
        this.emitSearchIfEligible(value, false);
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  handleInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.inputValue = value;
    this.input$.next(value);
    if ((value ?? "").trim().length === 0) {
      this.showDropdown = false;
    }
  }

  search(): void {
    this.emitSearchIfEligible((this.inputValue ?? "").trim(), true);
  }

  private emitSearchIfEligible(value: string, force: boolean): void {
    if (!value) {
      this.onType("", false);
      this.showDropdown = false;
      return;
    }

    if (!force && value.length < this.minChars) {
      this.showDropdown = false;
      return;
    }

    this.onType(value, force);
    this.showDropdown = this.loading || this.options.length > 0;
  }

  handleOptionClick(option: any): void {
    this.onOptionClick(option);
    this.inputValue = "";
    this.showDropdown = false;
  }

  hideDropdown(): void {
    setTimeout(() => (this.showDropdown = false), 200);
  }

  close(): void {
    this.options = [];
    this.inputValue = "";
  }
}
